import {
  Environment,
  AppType,
  Configuration,
} from '../../../../src/core/environment';

export const environment: Environment = {
  production: false,
  appType: AppType.Web,
  configuration: Configuration.Dev,
  baseUrl: 'http://localhost:4200',
  firebase: {
    apiKey: "AIzaSyC_CVCXz6IKFhrpqb7zNP7Bu-yhtr2T0mM",
    authDomain: "ososo-dev.firebaseapp.com",
    projectId: "ososo-dev",
    storageBucket: "ososo-dev.appspot.com",
    messagingSenderId: "516892809934",
    appId: "1:516892809934:web:7acbd9d0bde037e1a34e9f"
  },
};
